import { create } from 'zustand';

const useDialogStore = create((set) => ({
  isOpen: false,
  title: '',
  message: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  type: 'info', // 'danger' | 'warning' | 'info' | 'success'
  onConfirm: null,
  onCancel: null,
  
  confirm: ({ title, message, confirmText = 'Confirm', cancelText = 'Cancel', type = 'info', onConfirm, onCancel }) => {
    set({
      isOpen: true,
      title,
      message,
      confirmText,
      cancelText,
      type,
      onConfirm: () => {
        if (onConfirm) onConfirm();
        set({ isOpen: false });
      },
      onCancel: () => {
        if (onCancel) onCancel();
        set({ isOpen: false });
      }
    });
  },
  
  alert: ({ title, message, confirmText = 'OK', type = 'info', onConfirm }) => {
    set({
      isOpen: true,
      title,
      message,
      confirmText,
      cancelText: '', // Empty cancelText acts as single action button (OK only)
      type,
      onConfirm: () => {
        if (onConfirm) onConfirm();
        set({ isOpen: false });
      },
      onCancel: () => set({ isOpen: false })
    });
  },
  
  close: () => set({ isOpen: false })
}));

export default useDialogStore;
